import { GetterTree, MutationTree, ActionTree } from "vuex";
import { CategoryApi } from "@/services/api/CategoryApi";

class State {
  isCategoryBusy: boolean;
  categoryItems: unknown [];
  categoryItem: unknown;
}

// Создаем объект
const categoryApi = new CategoryApi();

// Создаем геттеры
const getters = <GetterTree<State, any>>{

  isCategoryBusy(state): boolean {
    return state.isCategoryBusy;
  },

  getCategoryItems(state): unknown[] {
    return state.categoryItems;
  },

  getCategoryItem(state): unknown {
    return state.categoryItem;
  }
};

// Создаем мутации
const mutations = <MutationTree<State>>{

  setIsCategoryBusy(state, payload: boolean) {
    state.isCategoryBusy = payload
  },

  setCategoryItems(state, payload: unknown[]) {
    state.categoryItems = payload
  },

  setCategoryItem(state, payload: unknown) {
    state.categoryItem = payload
  }
};

// Создаем действия
const actions = <ActionTree<State, any>>{
  
  // Устанавливаем элемент
  setCategoryItem({ commit }, data: any) {
    commit('setCategoryItem', data);
  },
  
  // Список элементов
  getCategoryItems({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsCategoryBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};
    const sort:any = data !== undefined && data.sort !== undefined ? data.sort : {};
    const pagination:any = data !== undefined && data.pagination !== undefined ? data.pagination : {};

    return new Promise((resolve, reject) => {

      // Получаем список элементов
      categoryApi.getCategoryItems(filter, sort, pagination)
        .then(
          (response) => {
            commit('setCategoryItems', response);
            commit('setIsCategoryBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCategoryBusy', false);
            reject(error);
          }
        );
    });
  },

  // Получить элемент
  getCategoryItem({ commit }, data: any) {

    // Устанавливаем событие загрузки
    commit('setIsCategoryBusy', true);

    const filter:any = data !== undefined && data.filter !== undefined ? data.filter : {};

    return new Promise((resolve, reject) => {

      // Получаем элемент
      categoryApi.getCategoryItem(filter)
        .then(
          (response) => {
            commit('setCategoryItem', response);
            commit('setIsCategoryBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCategoryBusy', false);
            reject(error);
          }
        );
    });
  },

  // Создать элемент
  createCategoryItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCategoryBusy', true);

    return new Promise((resolve, reject) => {

      // Создаем элемент
      categoryApi.createCategoryItem(data)
        .then(
          (response) => {
            commit('setIsCategoryBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCategoryBusy', false);
            reject(error);
          }
        );
    });
  },

  // Обновить элемент
  updateCategoryItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCategoryBusy', true);

    return new Promise((resolve, reject) => {

      // Обновляем элемент
      categoryApi.updateCategoryItem(data)
        .then(
          (response) => {
            commit('setIsCategoryBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCategoryBusy', false);
            reject(error);
          }
        );
    });
  },

  // Удалить элемент
  deleteCategoryItem({ commit }, data) {

    // Устанавливаем событие загрузки
    commit('setIsCategoryBusy', true);

    return new Promise((resolve, reject) => {

      // Удаляем элемент
      categoryApi.deleteCategoryItem(data)
        .then(
          (response) => {
            commit('setIsCategoryBusy', false);
            resolve(response);
          },
          (error) => {
            commit('setIsCategoryBusy', false);
            reject(error);
          }
        );
    });
  }
};

// Создаем модуль
const CategoryModule = {
  state: new State(),
  mutations: mutations,
  actions: actions,
  getters: getters
};

export default CategoryModule;